import "Styles/UIKit/uikit.scss";

import "lazysizes";

import { initFooter } from "./initFooter";
import { initPortalMenu } from "./initPortalMenu";
import { initHeader } from "./initHeader";


initHeader();

initPortalMenu();

initFooter();